import { useEffect } from 'react';
import { getVocabulary } from '@plone/volto/actions/vocabularies/vocabularies';
import { useDispatch, useSelector } from 'react-redux';

const withVocabulary = (vocabName) => (WrappedComponent) => {
  return (props) => {
    const dispatch = useDispatch();
    const vocab_items = useSelector(
      (state) => state.vocabularies?.[vocabName]?.items ?? [],
    );

    useEffect(() => {
      dispatch(
        getVocabulary({
          vocabNameOrURL: vocabName,
          size: 200,
        }),
      );
    }, [dispatch]);

    return (
      <WrappedComponent
        {...props}
        choices={vocab_items.map((v) => [v.value, v.label])}
      />
    );
  };
};

export default withVocabulary;
